import { render, staticRenderFns } from "./ViewPriceList.vue?vue&type=template&id=df370808&"
import script from "./ViewPriceList.vue?vue&type=script&lang=js&"
export * from "./ViewPriceList.vue?vue&type=script&lang=js&"
import style0 from "./ViewPriceList.vue?vue&type=style&index=0&id=df370808&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports